import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/factorial-one-react'

import Callout from 'modules/core/components/Callout'

import { Validation } from 'modules/integrations/hooks/SyncContext/validations'

export type ValidationCalloutProps = {
  validation: Validation
}

export function ValidationCallout({ validation }: ValidationCalloutProps) {
  const navigate = useNavigate()

  const buttonAvailable = validation.buttonUrl && validation.buttonLabel

  const linkAction = (
    <Button
      variant="outline"
      label={validation.buttonLabel}
      onClick={() => {
        validation.buttonUrl && navigate(validation.buttonUrl)
      }}
    />
  )

  return (
    <Callout
      type="critical"
      title={validation.title}
      description={validation.description}
      action={buttonAvailable ? linkAction : undefined}
    />
  )
}
